import 'angular:locale/data:zh-Hans';
import 'angular:locale/data:en-US';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
